// Theme: static-blossom
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'static-blossom',
  name: 'STATIC BLOSSOM',
  tagline: 'STATIC BLOSSOM',
  description: 'Lavanda acinzentada com geometria limpa e clima tecnico suave.',
  category: 'neon-cyber',
  tier: 'common',
  basePrice: 1575,
  swatches: ['#1E1F2A', '#2A2B3A', '#DDD6FE', '#EDE9FE'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '10px',
      '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-mono theme-static-blossom'
  },
  colorVars: {
    '--accent': '#DDD6FE',
    '--accent-foreground': '#1E1F2A',
    '--background': '#1E1F2A',
    '--border': '#6A6D8A',
    '--card': '#2A2B3A',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 40%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#EDE9FE',
    '--card-glow': 'color-mix(in srgb, var(--primary) 6%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#1E1F2A',
    '--foreground': '#EDE9FE',
    '--hold-fill': '#DDD6FE',
    '--input': '#6A6D8A',
    '--modal-bg': '#1E1F2A',
    '--modal-border': '#6A6D8A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#6A6D8A',
    '--muted-foreground': '#EDE9FE',
    '--nav-active': '#DDD6FE',
    '--nav-bg': '#2A2B3A',
    '--popover': '#2A2B3A',
    '--popover-foreground': '#EDE9FE',
    '--primary': '#DDD6FE',
    '--primary-foreground': '#1E1F2A',
    '--ring': '#DDD6FE',
    '--secondary': '#6A6D8A',
    '--secondary-foreground': '#EDE9FE',
    '--streak': '#DDD6FE',
    '--success': '#22c55e',
    '--success-foreground': '#1E1F2A',
    '--xp': '#DDD6FE',
    '--xp-bg': '#2A2B3A'
  },
  resolvedVars: {
    '--accent': '#DDD6FE',
    '--accent-foreground': '#1E1F2A',
    '--accent-foreground-hsl': '235 17% 14%',
    '--accent-foreground-oklch': 'from #1E1F2A l c h',
    '--accent-hsl': '251 95% 92%',
    '--accent-oklch': 'from #DDD6FE l c h',
    '--background': '#1E1F2A',
    '--background-hsl': '235 17% 14%',
    '--background-oklch': 'from #1E1F2A l c h',
    '--border': '#6A6D8A',
    '--border-hsl': '234 13% 48%',
    '--border-oklch': 'from #6A6D8A l c h',
    '--border-w': '1px',
    '--card': '#2A2B3A',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 40%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#EDE9FE',
    '--card-foreground-hsl': '251 91% 95%',
    '--card-foreground-oklch': 'from #EDE9FE l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 6%, transparent)',
    '--card-hsl': '236 16% 20%',
    '--card-oklch': 'from #2A2B3A l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#1E1F2A',
    '--destructive-foreground-hsl': '235 17% 14%',
    '--destructive-foreground-oklch': 'from #1E1F2A l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#EDE9FE',
    '--foreground-hsl': '251 91% 95%',
    '--foreground-oklch': 'from #EDE9FE l c h',
    '--hold-fill': '#DDD6FE',
    '--hold-fill-hsl': '251 95% 92%',
    '--hold-fill-oklch': 'from #DDD6FE l c h',
    '--input': '#6A6D8A',
    '--input-hsl': '234 13% 48%',
    '--input-oklch': 'from #6A6D8A l c h',
    '--modal-bg': '#1E1F2A',
    '--modal-bg-hsl': '235 17% 14%',
    '--modal-bg-oklch': 'from #1E1F2A l c h',
    '--modal-border': '#6A6D8A',
    '--modal-border-hsl': '234 13% 48%',
    '--modal-border-oklch': 'from #6A6D8A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#6A6D8A',
    '--muted-foreground': '#EDE9FE',
    '--muted-foreground-hsl': '251 91% 95%',
    '--muted-foreground-oklch': 'from #EDE9FE l c h',
    '--muted-hsl': '234 13% 48%',
    '--muted-oklch': 'from #6A6D8A l c h',
    '--nav-active': '#DDD6FE',
    '--nav-active-hsl': '251 95% 92%',
    '--nav-active-oklch': 'from #DDD6FE l c h',
    '--nav-bg': '#2A2B3A',
    '--nav-bg-hsl': '236 16% 20%',
    '--nav-bg-oklch': 'from #2A2B3A l c h',
    '--popover': '#2A2B3A',
    '--popover-foreground': '#EDE9FE',
    '--popover-foreground-hsl': '251 91% 95%',
    '--popover-foreground-oklch': 'from #EDE9FE l c h',
    '--popover-hsl': '236 16% 20%',
    '--popover-oklch': 'from #2A2B3A l c h',
    '--primary': '#DDD6FE',
    '--primary-foreground': '#1E1F2A',
    '--primary-foreground-hsl': '235 17% 14%',
    '--primary-foreground-oklch': 'from #1E1F2A l c h',
    '--primary-hsl': '251 95% 92%',
    '--primary-oklch': 'from #DDD6FE l c h',
    '--radius': '10px',
    '--ring': '#DDD6FE',
    '--ring-hsl': '251 95% 92%',
    '--ring-oklch': 'from #DDD6FE l c h',
    '--secondary': '#6A6D8A',
    '--secondary-foreground': '#EDE9FE',
    '--secondary-foreground-hsl': '251 91% 95%',
    '--secondary-foreground-oklch': 'from #EDE9FE l c h',
    '--secondary-hsl': '234 13% 48%',
    '--secondary-oklch': 'from #6A6D8A l c h',
    '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#DDD6FE',
    '--streak-hsl': '251 95% 92%',
    '--streak-oklch': 'from #DDD6FE l c h',
    '--success': '#22c55e',
    '--success-foreground': '#1E1F2A',
    '--success-foreground-hsl': '235 17% 14%',
    '--success-foreground-oklch': 'from #1E1F2A l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(251 95% 92% / 0.15)',
    '--xp': '#DDD6FE',
    '--xp-bg': '#2A2B3A',
    '--xp-bg-hsl': '236 16% 20%',
    '--xp-bg-oklch': 'from #2A2B3A l c h',
    '--xp-hsl': '251 95% 92%',
    '--xp-oklch': 'from #DDD6FE l c h'
  }
}
